import * as React from 'react';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Field, FormRenderProps } from 'react-final-form';

import { Box, Button, Typography } from '@mui/material';
import { RenderPromptField } from '@components/forms/VisualAdjustmentsForm/fields/RenderPromptField';
import { RenderRatioField } from '@components/forms/VisualAdjustmentsForm/fields/RenderRatioField';
import { RenderStyleField } from '@components/forms/VisualAdjustmentsForm/fields/RenderStyleField';
import { RenderMagicField } from '@components/forms/VisualAdjustmentsForm/fields/RenderMagicField';

// RENDER_FIELDS
import { schema } from './schema';
import { styles } from './styles';
import { useSelector } from 'react-redux';
import { getIsPromptFetching } from '@bus/projects/selectors';

const VisualAdjustmentsForm = ({
  isCurrentPrompt,
  ...props
}: FormRenderProps & { isCurrentPrompt: boolean }) => {
  const isFetching = useSelector(getIsPromptFetching);

  return (
    <form noValidate onSubmit={props.handleSubmit}>
      <Box width={'100%'} display={'flex'} flexDirection={'column'}>
        <Field name={`prompt`} component={RenderPromptField} />
        <Field name={`ratio`} component={RenderRatioField} />
        <Field name={`style`} component={RenderStyleField} />
        {/*FIELDS*/}
        <Box display={'flex'} mt={'20px'}>
          <Button
            fullWidth
            type={'submit'}
            role={'submit'}
            variant={'primary'}
            sx={styles.button}
            disabled={isFetching || !isCurrentPrompt}>
            <Typography variant={'body1'}>Generate image</Typography>
          </Button>
        </Box>
        <Field name={`magic`} type={'checkbox'} component={RenderMagicField} />
      </Box>
    </form>
  );
};

export default VisualAdjustmentsForm;

export { schema, VisualAdjustmentsForm };

/*
Paste to the component where you want to use the form

import { EvneFinalForm } from '@packages/evne-form';
import { schema, VisualAdjustmentsForm } from '@components/forms/VisualAdjustmentsForm';

<EvneFinalForm
  component={VisualAdjustmentsForm}
  schema={schema}
/>
* */
